import { action } from 'typesafe-actions';

const entity = 'rates';

const GET_RATES = `${entity}/get_rates`;
const SET_RATES = `${entity}/set_rates`;

const actionGetRates = () =>
  action(GET_RATES);
const actionSetRates = (rates: any) =>
  action(SET_RATES, rates);


export {
  GET_RATES,
  SET_RATES,
  actionGetRates,
  actionSetRates,
};